import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/text-area"

interface AgentEntryFormData {
  agent_changelog_entry: {
    title: string
    body: string
  }
}

interface AgentEntryFormProps {
  form: {
    data: AgentEntryFormData
    setData: (
      key: keyof AgentEntryFormData,
      value: AgentEntryFormData[keyof AgentEntryFormData],
    ) => void
    processing: boolean
    errors: Record<string, string>
    reset: () => void
  }
  onCancel: () => void
  submitLabel?: string
}

export default function AgentEntryForm({
  form,
  onCancel,
  submitLabel = "Publish",
}: AgentEntryFormProps) {
  const { data, setData, processing, errors, reset } = form

  function handleCancel() {
    reset()
    onCancel()
  }

  return (
    <>
      <div className="space-y-6 py-4">
        <div className="grid gap-2">
          <Label htmlFor="title">Title</Label>
          <Input
            id="title"
            name="title"
            type="text"
            placeholder="Short summary of the update"
            value={data.agent_changelog_entry.title}
            onChange={(e) =>
              setData("agent_changelog_entry", {
                ...data.agent_changelog_entry,
                title: e.target.value,
              })
            }
            autoFocus
          />
          <InputError message={errors["agent_changelog_entry.title"]} />
        </div>

        <div className="grid gap-2">
          <Label htmlFor="body">Summary</Label>
          <Textarea
            id="body"
            name="body"
            placeholder="Describe what changed, why it changed, and any relevant impact"
            value={data.agent_changelog_entry.body}
            onChange={(e) =>
              setData("agent_changelog_entry", {
                ...data.agent_changelog_entry,
                body: e.target.value,
              })
            }
            rows={4}
          />
          <InputError message={errors["agent_changelog_entry.body"]} />
        </div>
      </div>

      <div className="flex justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          onClick={handleCancel}
          disabled={processing}
        >
          Cancel
        </Button>
        <Button type="submit" disabled={processing} loading={processing}>
          {submitLabel}
        </Button>
      </div>
    </>
  )
}
